// extracted by mini-css-extract-plugin
export default {"wrapper":"activity_vacancies-module___wrapper___dde9dc5c","header":"activity_vacancies-module___header___ea053af9","closeButton":"activity_vacancies-module___closeButton___e6c03576"};